import { colors, Input, FormControl, Textarea } from '@spaceshipapp/cambridge';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const FormWrapper = styled.form`
  width: 31.25rem;
  margin: 1rem;
  position: relative;
  background: ${colors.surface};
  border-radius: 8px;
  padding: 2rem;
`;

export const Header = styled.div`
  display: flex;
  margin-top: 1rem;
  padding: 1.5rem;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  border-top: 0.2rem solid;
  color: ${colors.subtext};
  font-weight: 500;
`;

export const InputWrapper = styled.div`
  display: flex;
  padding-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
`;

export const InputLabel = styled.span`
  font-size: 1.2rem;
  text-align: left;
  width: 40%;
`;

export const CouponInput = styled(Input)`
  font-size: 1rem;
  width: 40%;
`;

export const CouponTextarea = styled(Textarea)`
  font-size: 1rem;
  width: 25.625rem;
  position: relative;
  padding: 0.5rem;
  &:focus {
    outline: none;
  }
`;

export const TextareaWrapper = styled.div`
  width: 100%;
  padding-bottom: 1rem;
  color: ${colors.text};
`;

export const CouponFormControl = styled(FormControl)`
  position: relative;
  width: 90%;
  margin-bottom: 1.5rem;
`;
